/*
 *  OBSOLETE FILE - This reducer is no longer included in index.js
 */
import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Set } from 'immutable';
import { ProjectActions } from '../actions/project';
import { AuthActions } from '../actions/auth';
import { UserActions } from '../actions/user';

const projectActions = getActionIds(ProjectActions);
const userActions = getActionIds(UserActions);
const authActions = getActionIds(AuthActions);

const initialState = Immutable.fromJS({
  projectsUsers: {},
  // projectsUsers: {
  //   project_id: [
  //     user_id,
  //     user_id,
  //   ],
  // }
});

export const projectsUsers = createStore(initialState, {
  [projectActions.resetReducers]: () => initialState,

  [authActions.getMeProjects.success]: (state, action) => {
    // This reducer is not 100% accurate with the changes to getMeProjects where the results will
    // contain: projects that you assigned to AND projects ur not assigned to but an account admin of
    // currently, we don't have any components that will be affected by this not having accurate data
    // so no changes will be made - accurate projects assigned to users will be in the users reducer
    // under users.roles.project
    const projects = action.result.entities.projects;

    if (!projects) return state;

    const userProjects = Object.keys(projects).reduce((p, key) => {
      const c = projects[key];
      if (!p[c.id]) {
        p[c.id] = Set();
      }
      p[c.id] = p[c.id].add(c.me);
      return p;
    }, {});

    // const userProjects = Object.keys(projects).reduce((p, key) => {
    //   const c = projects[key];
    //   const x = { ...p };
    //   if (!x[c.id]) {
    //     x[c.id] = Set();
    //   }
    //   x[c.id] = x[c.id].add(c.me);
    //   return x;
    // }, {});

    return state.mergeDeep({
      projectsUsers: Immutable.fromJS(userProjects),
    });
  },

  [projectActions.copyProject.success]: (state, action) => {
    const projectId = action.result.result;
    return state.setIn(['projectsUsers', projectId], Set(action.args[1]));
  },

  [projectActions.deleteProject.success]: (state, action) => {
    const projectId = action.args[0];
    return state.deleteIn(['projectsUsers', projectId]);
  },

  [userActions.addProjectUser.success]: (state, action) => {
    const projectId = action.args[0].toString();
    const userResult =
      action.result.entities.users || action.result.entities.pendingUsers;
    const userId = Object.keys(userResult)[0];
    const projectUserSet = Set().add(userId);
    const pu = {
      [projectId]: projectUserSet,
    };
    return state.mergeDeep({
      projectsUsers: Immutable.fromJS(pu),
    });
  },

  [projectActions.removeProjectUser.success]: (state, action) => {
    const projectId = action.result.projectId;
    const userId = action.result.userId;
    const removedUser = state
      .getIn(['projectsUsers', projectId])
      .delete(userId);
    // const removedUserIdx = removedUser.findIndex(u => u === userId);
    return state.setIn(['projectsUsers', projectId], removedUser);
  },

  [projectActions.getProject.success]: (state, action) => {
    const projects = action.result.entities.projects;
    const pu = Object.keys(projects).reduce((p, key) => {
      const c = projects[key];
      const users = c.users.map(u => u.id) || [];
      if (!p[c.id]) {
        p[c.id] = Set();
      }
      p[c.id] = Set(users);
      return p;
    }, {});

    return state.mergeDeep({
      projectsUsers: Immutable.fromJS(pu),
    });
  },
});

export const projectsUsersSelector = state => state.projectsUsers.get('projectsUsers');

export const filterProjectUsers = (projectsUsers, users, projectId) => {
  return projectsUsers.get(projectId, Set()).reduce((p, userId) => {
    const user = users.get(userId, null);

    if (user) {
      return p.concat(user);
    }

    return p;
  }, []);
}



// WEBPACK FOOTER //
// ./src/reducers/projectsUsers.js